import React from 'react';
import PropTypes from 'prop-types';
import memoizeOne from 'memoize-one';
import { useTranslation } from 'react-i18next';
import { languages, fallback_language } from 'config';

import { __t } from '@mssgme/shared';

import SelectSimple from '../SelectSimple';
import countries from './countries';

const priorityCountries = ['UA', 'KZ', 'US'];
const separator = (key) => ({
    label: '--------------------',
    value: 'separator' + key,
    disabled: true,
});

export const getDefaultCountriesOptions = memoizeOne((lang) => {
    const availableLang = languages.includes(lang) ? lang : fallback_language;
    const countriesArray = Object.values(countries)
        .map((item) => ({
            label: item[`${availableLang}_name`],
            value: `${item.alpha_2}-${item.alpha_3}`,
            alpha_2: item.alpha_2,
        }))
        .sort((item1, item2) => item1.label.localeCompare(item2.label));

    const prioritizedCountries = countriesArray
        .filter((country) => priorityCountries.includes(country.alpha_2))
        .sort((item1, item2) => priorityCountries.indexOf(item1.alpha_2) - priorityCountries.indexOf(item2.alpha_2));
    const restCountries = countriesArray.filter((country) => !prioritizedCountries.includes(country));

    return [{ label: __t('not_selected'), value: '' }, separator(1), ...prioritizedCountries, separator(2), ...restCountries];
});

const CountrySelect = ({ ...rest }) => {
    const { i18n } = useTranslation();

    return <SelectSimple {...rest} options={getDefaultCountriesOptions(i18n.language)} />;
};

CountrySelect.propTypes = {
    lang: PropTypes.string,
};

export default CountrySelect;
